import jQuery from 'jquery';
import { getCookie, setCookie } from '@shared/cookie';
import {
  getQueryStringValueByName,
  getURLParameter,
  getURLDomain,
} from '@shared/url';
import { cookieBase, languageCode } from 'server-data/flconfigs';

function isReferrerExternal(forCookie) {
  if (typeof forCookie === 'undefined') {
    forCookie = false;
  }

  const referrer = document.referrer;
  const referrerDomain = getURLDomain(document.referrer);
  if (referrer != null && referrer != '' && referrerDomain != document.domain) {
    // parse alternate domains from the <link> objects in the head
    const domains = jQuery('link[rel^="alternate"]').map(function() {
      return getURLDomain(jQuery(this).attr('href'));
    });

    // check current referrer
    for (let i = 0; i < domains.length; i++) {
      if (referrerDomain == domains[i]) {
        return false;
      }
    }

    return true;
  } else if (referrer === '' && !forCookie) {
    return true;
  }

  return false;
}

const _ttrefo = {
  MAX_FUNNELS: 10,

  push() {
    let errors = 0;

    for (let i = 0; i < arguments.length; i++) {
      const item = arguments[i];

      if (!(item instanceof Array) || item.length < 1) {
        errors++;
      } else {
        const action = item[0];
        const params = item.slice(1);
        if (typeof action !== 'string') {
          errors++;
        } else {
          switch (action) {
            case '_trackEvent':
              if (!this.trackEvent(params)) {
                errors++;
              }
              break;
            case '_trackEventNoCookie':
              if (!this.trackEventNoCookie(params)) {
                errors++;
              }
              break;
            case '_trackAction':
              if (!this.trackAction(params)) {
                errors++;
              }
              break;
            case '_setCookie':
              if (!this.setCookie(params)) {
                errors++;
              }
              break;
            case '_setEntrypoint':
              if (!this.setCookie(params)) {
                errors++;
              }
              break;
            case '_clearEntrypoint':
              if (!this.clearEntrypoint(params)) {
                errors++;
              }
              break;
            default:
              errors++;
              break;
          }
        }
      }
    }
    return errors;
  },

  trackEvent(params) {
    if (!(params instanceof Array) || params.length < 2) {
      return false;
    }

    const tt = params[0];
    const evnt = params[1];
    const label = params[2] || '';
    let name;
    let value;
    let reference;
    let referenceId;

    if (params.length > 4) {
      reference = params[3] || '';
      referenceId = params[4] || params[4] === 0 ? params[4] : '';
      name = params[5] || '';
      value = params[6] || params[6] === 0 ? params[6] : '';
    } else {
      value = params[3] || params[3] === 0 ? params[3] : '';
      name = '';
      reference = '';
      referenceId = '';
    }

    const funnels = this.getDataFromCookie();
    for (let i = 0; i < funnels.length; i++) {
      const funnel = this.splitTigerTeamEntrypoint(funnels[i]);
      if (funnel.tt === tt) {
        return this.pushToTracking(
          tt,
          evnt,
          funnel.entrypoint,
          label,
          value,
          name,
          reference,
          referenceId,
        );
      }
    }

    const resultQTS = this.pushToQTS('ttref:ev', {
      tt,
      event: evnt,
      entrypoint: 'others',
      label,
      value,
      name,
      reference,
      reference_id: referenceId,
    });
    return resultQTS;
  },

  trackAction(params) {
    if (!(params instanceof Array) || params.length < 3) {
      return false;
    }

    const tt = params[0];
    const evnt = params[1];
    const actionPoint = params[2];
    const sourceID = parseInt(params[3], 10) || 0;

    if (
      typeof tt !== 'string' ||
      typeof evnt !== 'string' ||
      typeof actionPoint !== 'string' ||
      typeof sourceID !== 'number'
    ) {
      return false;
    }

    return this.pushToQTS('ttref:action', {
      tt,
      event: evnt,
      action_point: actionPoint,
      action_page: document.location.pathname,
      source_id: sourceID,
    });
  },

  getDataFromCookie() {
    if (typeof JSON === 'undefined') {
      return false;
    }

    const cookieData = getCookie(`${cookieBase}_TTREF`);

    if (typeof cookieData !== 'string' || cookieData === '') {
      return [];
    }

    try {
      return JSON.parse(cookieData);
    } catch (e) {
      return [];
    }
  },

  trackEventNoCookie(params) {
    if (!(params instanceof Array) || params.length < 3) {
      return false;
    }

    const tt = params[0];
    const evnt = params[1];
    const entrypoint = params[2];
    const label = params[3] || '';
    let name;
    let value;
    let reference;
    let referenceId;

    if (params.length > 5) {
      reference = params[4] || '';
      referenceId = params[5] || params[5] === 0 ? params[5] : '';
      name = params[6] || '';
      value = params[7] || params[7] === 0 ? params[7] : '';
    } else {
      value = params[4] || params[4] === 0 ? params[4] : '';
      name = '';
      reference = '';
      referenceId = '';
    }

    return this.pushToTracking(
      tt,
      evnt,
      entrypoint,
      label,
      value,
      name,
      reference,
      referenceId,
    );
  },

  pushToTracking(
    tt,
    evnt,
    entrypoint,
    label,
    value,
    name,
    reference,
    referenceId,
  ) {
    try {
      const resultQTS = this.pushToQTS('ttref:ev', {
        tt,
        event: evnt,
        entrypoint,
        label,
        value,
        name: name || '',
        reference: reference || '',
        reference_id: referenceId || '',
      });
      return resultQTS;
    } catch (err) {
      return false;
    }
  },

  pushToQTS(evntName, data) {
    if (typeof _lt === 'object') {
      _lt.push([evntName, data]);
      return true;
    } else if (typeof _t === 'object') {
      _t.push([evntName, data]);
      return true;
    }

    return false;
  },

  setCookie(params) {
    if (!(params instanceof Array)) {
      return false;
    }

    let replace;
    let data;
    if (params.length > 0) {
      replace = false;
      data = params[0];
    } else {
      replace = true;
      data = getQueryStringValueByName('ttref');
    }

    if (
      typeof data !== 'string' ||
      data === '' ||
      typeof JSON === 'undefined'
    ) {
      return false;
    }

    const currentFunnel = this.splitTigerTeamEntrypoint(data);

    const qtsData = {
      section: currentFunnel.tt,
      subsection: 'ttref_set_entry_point',
      label: currentFunnel.entrypoint,
      reference: params[1] || '',
      reference_id: params[2] || params[2] === 0 ? params[2] : '',
      name: params[3] || '',
      value: params[4] || params[4] === 0 ? params[4] : '',
    };

    this.pushToQTS('user_action', qtsData);

    if (replace) {
      this.clearEntrypoint([currentFunnel.tt]);
    }

    if (this.getFunnel(currentFunnel.tt)) {
      return false;
    }

    const funnels = this.getDataFromCookie();
    while (funnels.length >= this.MAX_FUNNELS) {
      funnels.shift();
    }

    funnels.push(data);

    setCookie(`${cookieBase}_TTREF`, JSON.stringify(funnels), 1);
    return true;
  },

  clearEntrypoint(params) {
    if (!(params instanceof Array)) {
      return false;
    }

    if (params.length > 0) {
      const tt = params[0];

      if (typeof tt !== 'string') {
        return false;
      }

      const funnel = this.getFunnel(tt);
      const funnels = this.getDataFromCookie();
      const funnelIndex = funnels.indexOf(`${funnel.tt}_${funnel.entrypoint}`);

      if (funnelIndex !== -1) {
        funnels.splice(funnelIndex, 1);
        setCookie(`${cookieBase}_TTREF`, JSON.stringify(funnels), 1);
      }
    } else {
      setCookie(`${cookieBase}_TTREF`, '', -1);
    }

    return true;
  },

  splitTigerTeamEntrypoint(data) {
    if (typeof data !== 'string') {
      return false;
    }

    const dataSplit = data.split('_');

    if (dataSplit.length === 2) {
      return { tt: dataSplit[0], entrypoint: dataSplit[1] };
    }

    return false;
  },

  getFunnel(tt) {
    const funnels = this.getDataFromCookie();

    for (let i = 0; i < funnels.length; i++) {
      const funnel = this.splitTigerTeamEntrypoint(funnels[i]);
      if (tt === funnel.tt) {
        return funnel;
      }
    }
    return false;
  },

  pushReferrerToQTS() {
    if (typeof isReferrerExternal !== 'undefined') {
      // Get utm_referrer for GA Content Experiments
      let utmReferrer = false;
      try {
        utmReferrer = getURLParameter('utm_referrer');
      } catch (err) {
        return false;
      }

      // Check if referrer is external
      const external = isReferrerExternal();

      if (external || utmReferrer) {
        // Adwords check
        let query = '';
        const regexString = '[\\?&]q=([^&#]*)';
        const regex = new RegExp(regexString);
        const results = regex.exec(document.referrer);
        if (results !== null) {
          query = decodeURIComponent(results[1].replace(/\+/g, ' '));
        }

        // Check language and check if new user
        let newUser = false;
        let lang = false;
        try {
          const notNew = getCookie(`${cookieBase}_NOTNEW`);
          if (!notNew) {
            newUser = true;
          }

          lang = languageCode;
        } catch (err) {
          newUser = 'error';
        }

        // Referrer
        let url = document.referrer;
        if (!external && utmReferrer) {
          url = utmReferrer;
        }

        // Push data to QTS referrer event
        this.pushToQTS('referrer', {
          url,
          q: query,
          new_user: newUser,
          language: lang,
        });
      }
    }

    if (typeof getQueryStringValueByName === 'function') {
      // function exists, so we can now call it
      const mkwid = getQueryStringValueByName('mkwid');
      const crid = getQueryStringValueByName('crid');
      const mpKw = getQueryStringValueByName('mp_kw');
      const mpMt = getQueryStringValueByName('mp_mt');
      const gclid = getQueryStringValueByName('gclid');
      if (
        mkwid !== '' ||
        crid !== '' ||
        mpKw !== '' ||
        mpMt !== '' ||
        gclid !== ''
      ) {
        this.pushToQTS('adwords:click', {
          mkwid,
          crid,
          mp_kw: mpKw,
          mp_mt: mpMt,
          gclid,
        });
      }
    }
  },
};

const _ttreft = _ttref;
_ttref = _ttrefo;
_ttref.pushReferrerToQTS();
_ttref.push(..._ttreft);
